import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { approveFranchiseRequest, approveInvestRequest, getAllFranchaise, getAllInvestor } from '../../redux/actions/AllActions';
import { Button, Layout, message, Modal, Select, Space, Table } from 'antd';
import { Option } from 'antd/es/mentions';
import { Content } from 'antd/es/layout/layout';
import Loading from '../../components/Loading/Loading';
import Filter from '../../components/Filter/Filter';
import { deleteInvestor } from '../../api/investor';


const Investor = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { data ,loading} = useSelector((state) => state.data);



    const [filteredItems, setFilteredItems] = useState([]);
        const [isEditingModelVisible, setIsEditingModelVisible] = useState(false);
        const [isCreateModelVisible, setIsCreateModelVisible] = useState(false);
        const [handleDetailsVisible, setHandleDetailsVisible] = useState(false);
        const [editingRecord, setEditingRecord] = useState(null);
    
    const [admin, setAdmin] = useState("");
      useEffect(() => {
            const adminData = localStorage.getItem("admindata");
            try {
                const parsedData = JSON.parse(adminData);
                if (parsedData && typeof parsedData === "object") {
                    setAdmin(parsedData);
                } else {
                    console.error("Invalid admin data structure");
                    localStorage.removeItem("admindata");
                }
            } catch (error) {
                console.error("Error parsing admin data:", error);
                localStorage.removeItem("admindata");
            }
      }, []);
    const handleDetails = (record) => {
        setEditingRecord(record);
        setHandleDetailsVisible(true);
    };

    const handleEditCancel = () => {
        setIsEditingModelVisible(false);
    };
    const handleEdit = (record) => {
        setEditingRecord(record);
        setIsEditingModelVisible(true);
    };
    const handleDelete = (record) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this investor?',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk: async () => {
                try {
                    const resp = await (deleteInvestor(record._id));
                    if (resp?.data?.success) {
                        fetch();
                        message.success('Investor deleted successfully');
                    } else {
                        message.error('Failed to delete user');
                    }
                } catch (error) {
                    message.error('An error occurred while deleting the user');
                }
            },
        });



    };

    
    const handleChangeStatus = async (e,record) => {
        try {
            const response = await approveInvestRequest(e,record?._id)
            dispatch(getAllInvestor());
            message.success("Status Changed Successfully")
        } catch (e) {
            // alert("Changing Status of Franchise failed")
            message.error("Changing Status of Investor failed")

        }
    }
    
    const columns = [


        {
            title: "Paid",
            dataIndex: 'isApproved',
            key: 'isApproved',
            width: 300,
            render: (_, record) => (<Space>
                {record?.payment_status === "paid" ?
                    <div
                        style={{
                            background: "green",

                            color: "white",
                            padding: "10px 20px",
                            borderRadius: "2px",
                            fontWeight: 'bold',
                            letterSpacing: "1px",
                            fontSize: "13px",
                            width: "120px",
                            textAlign: "center"
                        }}
                    >
                        Paid
                    </div>
                    : <div

                        style={{
                            background: "red",
                            color: "white",
                            padding: "10px 20px",
                            borderRadius: "2px",
                            fontWeight: 'bold',
                            letterSpacing: "1px",
                            fontSize: "13px",
                            width: "120px",
                            textAlign: "center"
                        }}
                    >
                        Not Paid
                    </div>
                }

            </Space>)
        },
        {
            title: "Approve",
            dataIndex: 'status',
            key: 'status',
            width: 300,
            render: (_, record) => (<Space>
                <div>
                    <Select
                        disabled={record?.payment_status !== 'paid' || record?.status === 'accepted'}
                        style={{
                            width: "100px"
                        }}
                        onChange={(e) => { handleChangeStatus(e,record) }}
                        value={record.status}>
                        <Option value="pending">Pending</Option>
                        <Option value="rejected">Reject</Option>
                        <Option value="accepted">Accept</Option>
                    </Select>
                </div>
                

            </Space>)
        },
        {
            title: "Name ",
            dataIndex: 'user',
            key: 'status',
            width: 300,
            render: (_, record) => {
                return (<div>
                    {record?.user?.name}
                </div>)
                
            }
        },
        {
            title: "Email ",
            dataIndex: 'user',
            key: 'status',
            width: 300,
            render: (_, record) => {
                return (<div>
                    {record?.user?.email}
                </div>)

            }
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space


                >

                    {
                        // admin?.role === 'superAdmin' &&
                        <div
                            style={{
                                display: 'flex',
                                width: "200px",


                            }}
                        >
                            {/* <Button type="link" onClick={() => handleEdit(record)}>
                                Edit
                            </Button>
                            <Button type="link" onClick={() => handleDetails(record)}>
                                Details
                            </Button> */}
                            <Button type="link" danger onClick={() => handleDelete(record)}>
                                Delete
                            </Button>

                        </div>
                    }     </Space>
            ),
            fixed: 'right'
        },
    ];
     const fetch = () => {
            dispatch(getAllInvestor());
        }

    
        useEffect(() => {
            fetch()
        }, [dispatch]);

        useEffect(() => {
            setFilteredItems(data);
        }, [data]);

  return (
      <div>
          {
              loading ?
                  <Loading/> :
                  <>
                      <Layout>
                        
                        
              <Content>
                  <div style={{ overflowX: 'auto', width: '100%' }}>
                      <Table
                          columns={columns}
                          pagination={{ position: ['bottomCenter'], pageSize: 10 }}
                          dataSource={filteredItems}
                          rowKey={(record) => record._id}
                          style={{ minHeight: '80vh', maxHeight: '80vh' }}
                      />
                  </div>
              </Content>
                      </Layout>
                  </>

          }         
    </div>
  )
}

export default Investor